import PropTypes from 'prop-types';

import RepairReportCommandBar from './RepairReportCommandBar';
import RepairReportInspectionItemsTable from './RepairReportInspectionItemsTable';
import RepairReportMainInfoCard from './RepairReportMainInfoCard';

const RepairReportBlock = ({
  detail,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <RepairReportMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <RepairReportCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <div className="border-t border-slate-200 px-4 py-4">
        <h2 className="mb-3 text-base font-semibold text-gray-800">檢測項目</h2>
        <RepairReportInspectionItemsTable
          items={
            detail?.inspectionItems
            ?? detail?.inspection?.inspectionItems
            ?? []
          }
        />
      </div>
    </div>
  </div>
);

RepairReportBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    repairReportNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    inspectionItems: PropTypes.arrayOf(PropTypes.object),
    inspection: PropTypes.shape({
      inspectionItems: PropTypes.arrayOf(PropTypes.object),
      inspectionConclusion: PropTypes.string,
    }),
    history: PropTypes.shape({
      refuseReason: PropTypes.string,
    }),
  }).isRequired,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default RepairReportBlock;
